/**
 * Card Component
 * Container with predefined styles
 */

import React, { forwardRef } from 'react';
import { Box } from '../primitives/Box';
import { useStyleConfig } from '../hooks/useStyleConfig';

/**
 * Card Component
 * 
 * @example
 * <Card>Card content</Card>
 * <Card variant="outline">Outlined card</Card>
 */
export const Card = forwardRef(({
  variant,
  size,
  ...props
}, ref) => {
  const styles = useStyleConfig('Card', { variant, size });

  return (
    <Box
      ref={ref}
      __css={styles}
      {...props}
    />
  );
});

Card.displayName = 'Card';

/**
 * CardHeader Component
 */
export const CardHeader = forwardRef((props, ref) => {
  return (
    <Box
      ref={ref}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={4}
      {...props}
    />
  );
});

CardHeader.displayName = 'CardHeader';

/**
 * CardBody Component
 */
export const CardBody = forwardRef((props, ref) => {
  return (
    <Box
      ref={ref}
      flex={1}
      {...props}
    />
  );
});

CardBody.displayName = 'CardBody';

/**
 * CardFooter Component
 */
export const CardFooter = forwardRef((props, ref) => {
  return (
    <Box
      ref={ref}
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      mt={4}
      gap={2}
      {...props}
    />
  );
});

CardFooter.displayName = 'CardFooter';

export default Card;
